import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-50 border-t border-background-200/50" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-bold text-primary-500 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              被窝影院
            </h3>
            <p className="text-foreground-600 text-sm leading-relaxed">
              汇聚免费电视剧大全，全集在线看最新电视剧免费、热播剧完整版和国产剧免费观看，高清流畅在线不缓冲，追剧首选平台。
            </p>
          </div>

          <div>
            <h4 className="text-foreground-800 font-semibold text-sm mb-4">快速导航</h4>
            <ul className="space-y-2">
              {[
                { label: '首页', path: '/' },
                { label: '国产剧', path: '/category/国产剧' },
                { label: '美剧', path: '/category/美剧' },
                { label: '韩剧', path: '/category/韩剧' },
                { label: '关于我们', path: '/about' },
              ].map((item) => (
                <li key={item.label}>
                  <Link to={item.path} className="text-foreground-600 hover:text-primary-500 text-sm transition-colors whitespace-nowrap cursor-pointer">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-800 font-semibold text-sm mb-4">热门分类</h4>
            <ul className="space-y-2">
              {['日剧', '动漫', '综艺', '纪录片', '港剧'].map((cat) => (
                <li key={cat}>
                  <Link to={`/category/${encodeURIComponent(cat)}`} className="text-foreground-600 hover:text-primary-500 text-sm transition-colors whitespace-nowrap cursor-pointer">
                    {cat}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-800 font-semibold text-sm mb-4">联系我们</h4>
            <ul className="space-y-2 text-foreground-600 text-sm">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500"></i>
                <span>contact@beiwoyingyuan.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-primary-500"></i>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-shield-check-line text-primary-500"></i>
                <span>安全 · 高清 · 不缓冲</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; {currentYear} 被窝影院 beiwoyingyuan.com 版权所有 | 本站内容仅供学习交流
          </p>
          <div className="flex items-center gap-4 text-foreground-500 text-xs">
            <a href="/about" className="hover:text-primary-500 transition-colors cursor-pointer">关于我们</a>
            <span className="text-background-300">|</span>
            <a href="/about" className="hover:text-primary-500 transition-colors cursor-pointer">联系方式</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;